import React from 'react';
import { ReactComponent as AdminIcon } from '../admin.svg';
import "./PrivilegeBadge.scss";
import { ReactComponent as DeletedUserIcon } from 'assets/img/deleted-user.svg';

const PrivilegeBadge: React.FC<{ privilege: string, notGroupMember?: boolean }> = (props) => {
    return (
        <div
            className="admin-label"
            style={{
                cursor: props.notGroupMember || props.privilege === 'Removed' ? 'auto' : 'pointer'
            }}
        >
            <div className="admin-label-icon-body">
                {
                    props.privilege === 'Removed'
                        ?
                        <div className='icon'>
                            <DeletedUserIcon />
                        </div>
                        :
                        <AdminIcon />
                }
            </div>
            <span className="admin-label-text">{" "}{props.privilege}</span>
        </div>
    )
}

export default PrivilegeBadge
